import React from 'react';
import { useTheme } from '../ThemeProvider';

function PlayerSilhouette() {
  return (
    <svg viewBox="0 0 200 240" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
      <defs>
        <linearGradient id="pen-sky" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor="#FFD86B" />
          <stop offset="1" stopColor="#FF8A4A" />
        </linearGradient>
        <pattern id="pen-dots" width="12" height="12" patternUnits="userSpaceOnUse">
          <circle cx="2" cy="2" r="1.3" fill="#16131522" />
        </pattern>
      </defs>
      <rect width="200" height="240" fill="url(#pen-sky)" />
      <rect width="200" height="240" fill="url(#pen-dots)" />
      <circle cx="150" cy="60" r="34" fill="#FFF4D6" stroke="#161315" strokeWidth="2.5" />
      <g transform="translate(100 240)">
        <path d="M -58 0 C -60 -70 -40 -110 0 -112 C 40 -110 60 -70 58 0 Z" fill="#161315" />
        <circle cx="0" cy="-130" r="28" fill="#161315" />
        <path d="M -30 -148 Q 0 -168 30 -148 L 36 -138 Q 0 -152 -36 -138 Z" fill="#2E5BFF" stroke="#161315" strokeWidth="2" />
        <rect x="34" y="-90" width="14" height="70" rx="3" fill="#E8C48C" stroke="#161315" strokeWidth="2" transform="rotate(18 40 -55)" />
        <path d="M -54 -40 L 54 -40" stroke="#FFC93A" strokeWidth="6" />
      </g>
    </svg>
  );
}

const MysteryCard = ({
  flipped,
  revealed,
  cricketerName = 'MYSTERY BATTER',
  cardNumber = '#047',
  backChildren,
  onTap,
}) => {
  const { theme } = useTheme();

  const wrap = { position: 'relative', width: '100%', height: '100%', perspective: 1200 };
  const inner = {
    position: 'absolute', inset: 0,
    transformStyle: 'preserve-3d',
    transform: flipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
    transition: 'transform 820ms var(--ease-snap)',
  };
  const face = {
    position: 'absolute', inset: 0,
    backfaceVisibility: 'hidden',
    WebkitBackfaceVisibility: 'hidden',
    borderRadius: 22,
    border: 'var(--border-ink)',
    boxShadow: 'var(--shadow-hard)',
    overflow: 'hidden',
  };

  const showOverlay = !revealed && !flipped;

  return (
    <div style={wrap} onClick={showOverlay ? onTap : undefined}>
      <div style={inner}>
        {/* FRONT */}
        <div style={{
          ...face,
          background: `linear-gradient(160deg, ${theme.pink} 0%, ${theme.yellow} 60%, ${theme.blue} 140%)`,
          cursor: showOverlay ? 'pointer' : 'default',
        }}>
          <div style={{
            position: 'absolute', inset: 10, borderRadius: 16,
            background: 'var(--c-cream)',
            border: '2px dashed var(--c-ink)',
            overflow: 'hidden',
            display: 'flex', flexDirection: 'column',
          }}>
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '8px 12px', background: 'var(--c-ink)', color: 'var(--c-cream)',
            }}>
              <span style={{ fontFamily: 'var(--font-display)', fontSize: 12, letterSpacing: 0.6 }}>MYSTERY BATTER</span>
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, opacity: 0.8 }}>{cardNumber}</span>
            </div>

            <div style={{
              position: 'relative', flex: 1,
              margin: 10, borderRadius: 12, overflow: 'hidden',
              border: '2px solid var(--c-ink)',
              clipPath: revealed ? 'inset(0 0 0 0)' : 'inset(0 0 0 100%)',
              transition: 'clip-path 700ms cubic-bezier(.8,.05,.2,1)',
            }}>
              <PlayerSilhouette />
              <div style={{
                position: 'absolute', inset: 0,
                background: 'linear-gradient(110deg, transparent 30%, rgba(255,255,255,.75) 48%, rgba(255,255,255,.95) 50%, rgba(255,255,255,.75) 52%, transparent 70%)',
                transform: 'translateX(-120%)',
                animation: revealed ? 'penSweep 700ms ease-out 60ms 1 forwards' : 'none',
                mixBlendMode: 'screen',
                pointerEvents: 'none',
              }} />
            </div>

            <div style={{
              margin: '0 10px 10px', padding: '10px 12px',
              borderRadius: 10, background: 'var(--c-yellow)',
              border: '2px solid var(--c-ink)',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              overflow: 'hidden',
              transform: revealed ? 'translateY(0)' : 'translateY(120%)',
              opacity: revealed ? 1 : 0,
              transition: 'transform 480ms var(--ease-snap) 350ms, opacity 320ms 350ms',
            }}>
              <div style={{
                fontFamily: 'var(--font-display)', fontSize: 18, letterSpacing: 0.5, lineHeight: 1,
                color: 'var(--c-ink)',
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                minWidth: 0, flex: 1,
              }}>{(cricketerName || '').toUpperCase()}</div>
              <div style={{
                fontFamily: 'var(--font-display)', fontSize: 12, padding: '4px 8px',
                background: 'var(--c-ink)', color: 'var(--c-yellow)', borderRadius: 6,
                marginLeft: 8,
                flexShrink: 0,
              }}>★</div>
            </div>

            {showOverlay && (
              <div style={{
                position: 'absolute', inset: 0, display: 'grid', placeItems: 'center',
                pointerEvents: 'none',
              }}>
                <div style={{
                  fontFamily: 'var(--font-display)', fontSize: 18, letterSpacing: 1.2,
                  color: 'var(--c-ink)', textAlign: 'center',
                  background: 'var(--c-cream)',
                  padding: '10px 14px',
                  border: '2.5px solid var(--c-ink)',
                  borderRadius: 12,
                  boxShadow: 'var(--shadow-hard-sm)',
                  animation: 'penPulseScale 1.6s ease-in-out infinite',
                }}>TAP TO REVEAL ★</div>
              </div>
            )}
          </div>

          <div style={{ position: 'absolute', top: 8, left: 8, fontFamily: 'var(--font-display)', fontSize: 14, color: 'var(--c-ink)' }}>★</div>
          <div style={{ position: 'absolute', top: 8, right: 8, fontFamily: 'var(--font-display)', fontSize: 14, color: 'var(--c-ink)' }}>★</div>
          <div style={{ position: 'absolute', bottom: 8, left: 8, fontFamily: 'var(--font-display)', fontSize: 14, color: 'var(--c-ink)' }}>★</div>
          <div style={{ position: 'absolute', bottom: 8, right: 8, fontFamily: 'var(--font-display)', fontSize: 14, color: 'var(--c-ink)' }}>★</div>
        </div>

        {/* BACK */}
        <div style={{ ...face, transform: 'rotateY(180deg)', background: '#FFFBEF' }}>
          <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            {backChildren}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MysteryCard;
